"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventPromotionAppliesToEnum = exports.EventPromotionDiscountTypeEnum = exports.EventPromotionTypeEnum = void 0;
var EventPromotionTypeEnum;
(function (EventPromotionTypeEnum) {
    EventPromotionTypeEnum["PreSale"] = "Presale";
    EventPromotionTypeEnum["Unlock"] = "Unlock";
    EventPromotionTypeEnum["Discount"] = "Discount";
    EventPromotionTypeEnum["LimitOverride"] = "Limit Override";
})(EventPromotionTypeEnum = exports.EventPromotionTypeEnum || (exports.EventPromotionTypeEnum = {}));
var EventPromotionDiscountTypeEnum;
(function (EventPromotionDiscountTypeEnum) {
    EventPromotionDiscountTypeEnum["Flat"] = "Flat";
    EventPromotionDiscountTypeEnum["Percent"] = "Percent";
})(EventPromotionDiscountTypeEnum = exports.EventPromotionDiscountTypeEnum || (exports.EventPromotionDiscountTypeEnum = {}));
var EventPromotionAppliesToEnum;
(function (EventPromotionAppliesToEnum) {
    EventPromotionAppliesToEnum["PerTicket"] = "Per Ticket";
    EventPromotionAppliesToEnum["PerOrder"] = "Per Order";
})(EventPromotionAppliesToEnum = exports.EventPromotionAppliesToEnum || (exports.EventPromotionAppliesToEnum = {}));
//# sourceMappingURL=IEventPromotion.js.map